module.exports = __webpack_public_path__ + "img/home-delivery-date-top-img.8ed67b3c.jpeg";